import * as React from 'react';
import { dateFormatter, DateFormat } from 'easit--localization';

export interface IDayFilterComponentProps {
    availableDates: Date[];
    selectedDate?: Date;
    onDateSelect: (dateToSelect: Date) => void;
}

export const DayFilterComponent: React.FC<IDayFilterComponentProps> = (props: IDayFilterComponentProps) => {
    return <div className="day-filter">
        {
            props.availableDates.map(item => <div
                key={item.toISOString()}
                className={`item ${item === props.selectedDate ? 'selected' : ''} `}
                onClick={() => { props.onDateSelect(item) }}
            >
                {dateFormatter.formatDateAsRelative(item, DateFormat.DayName)}
                <br />
                {dateFormatter.formatDate(item, DateFormat.DDMM)}
            </div>)
        }
    </div>
}